// assets
import { HomeOutlined, EnvironmentOutlined } from '@ant-design/icons';

// icons
const icons = {
  HomeOutlined,
  EnvironmentOutlined
};

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

const pages = {
  id: 'find-home',
  title: 'Find My Home',
  type: 'group',
  children: [
    {
      id: 'lot-selection',
      title: 'Lot Selection',
      type: 'item',
      url: '/find-home',
      icon: icons.EnvironmentOutlined
    }
 
  ]
};

export default pages;
